import {Component} from "@angular/core";
import {ICellRendererAngularComp} from "ag-grid-angular";

@Component({
    selector: 'app-filedownload',
    template: `
  <button title="Load To Vault" (click)="docdownload($event);" class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem">
  <i style="font-size: 10px;" class="fas fa-arrow-right"></i>
  </button>`,
    standalone: false
})
export class LoadToVault implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  docdownload($event) {
    console.log("hello")
    if (this.params.docdownload instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      console.log(params)
      this.params.docdownload(params);

    }
  }
}
